"use client";

import { useState } from "react";
import { useTranslations } from "next-intl";
import { submitFeedback } from "../lib/feedback";
import { useToast } from "../lib/toast";

export default function FeedbackForm({ compact = false }: { compact?: boolean }) {
	const [rating, setRating] = useState(0);
	const [content, setContent] = useState("");
	const [submitting, setSubmitting] = useState(false);
	const { notify } = useToast();
	const t = useTranslations("feedback");

	async function onSubmit() {
		if (rating < 1 || content.trim() === "") {
			notify(t("notifyRate"), "error");
			return;
		}
		setSubmitting(true);
		try {
			await submitFeedback(rating, content.trim());
			notify(t("notifyThanks"), "success");
			setRating(0);
			setContent("");
		} catch (e) {
			notify((e as Error).message || t("notifyFailed"), "error");
		} finally {
			setSubmitting(false);
		}
	}

	return (
		<div className={compact ? "cgFeedbackForm cgFeedbackCompact" : "cgFeedbackForm"}>
			<div className="cgStars" role="radiogroup" aria-label={t("ratingLabel")}>
				{[1, 2, 3, 4, 5].map((n) => (
					<button
						key={n}
						type="button"
						className={n <= rating ? "cgStar on" : "cgStar"}
						aria-label={t("star", { n })}
						aria-pressed={n <= rating}
						onClick={() => setRating(n)}
					>
						★
					</button>
				))}
			</div>
			<textarea
				className="cgFeedbackText"
				placeholder={t("placeholder")}
				value={content}
				maxLength={2000}
				onChange={(e) => setContent(e.target.value)}
			/>
			<button className="cgBtn cgBtnPrimary" disabled={submitting} onClick={onSubmit}>
				{submitting ? t("submitting") : t("submit")}
			</button>
		</div>
	);
}
